import { useState } from "react";
import { Grid, Num, Pick, Result, SHEETS, UNIT_MM, card, convertVals, fmt, sheetMM } from "./ui";

const BASIS = [["text", "Text / Book (25 × 38 in)", 1.48], ["cover", "Cover (20 × 26 in)", 2.708], ["bond", "Bond / Writing (17 × 22 in)", 3.76], ["index", "Index (25.5 × 30.5 in)", 1.805]];

function GsmLbs() {
  const [gsm, setGsm] = useState(300);
  const [lb, setLb] = useState(80);
  const [basis, setBasis] = useState("text");
  const f = BASIS.find(b => b[0] === basis)[2];
  return (
    <div style={card}>
      <b style={{ fontSize: 13 }}>GSM ↔ US pound (lb) basis weight</b>
      <div style={{ marginTop: 12 }}><Grid>
        <Pick testid="paper-basis" label="Paper grade" value={basis} onChange={setBasis} options={BASIS.map(b => [b[0], b[1]])}/>
        <Num testid="paper-gsm-in" label="GSM" value={gsm} onChange={setGsm}/>
        <Result testid="paper-gsm-to-lb" label="Equals" value={`${fmt((Number(gsm) || 0) / f, 1)} lb`}/>
        <Num testid="paper-lb-in" label="Pounds (lb)" value={lb} onChange={setLb}/>
        <Result testid="paper-lb-to-gsm" label="Equals" value={`${fmt((Number(lb) || 0) * f, 1)} GSM`}/>
      </Grid></div>
    </div>
  );
}

export function PaperTool() {
  const [sheet, setSheet] = useState("23x36in");
  const [unit, setUnit] = useState("in");
  const [p, setP] = useState({ W: 23, H: 36, gsm: 300, ream: 500, qty: 10000, kg: 100, rate: 0 });
  const set = (k) => (v) => setP({ ...p, [k]: v });
  const pre = sheetMM(sheet);
  const [wmm, hmm] = pre || [(Number(p.W) || 0) * UNIT_MM[unit], (Number(p.H) || 0) * UNIT_MM[unit]];
  const area = (wmm / 1000) * (hmm / 1000);
  const g = area * (Number(p.gsm) || 0);
  const reamKg = (g * (Number(p.ream) || 0)) / 1000;
  const totalKg = (g * (Number(p.qty) || 0)) / 1000;
  const perKg = g ? 1000 / g : 0;
  const rate = Number(p.rate) || 0;
  return (
    <div data-testid="tool-paper" style={{ display: "grid", gap: 16 }}>
      <div style={card}>
        <b style={{ fontSize: 13 }}>Sheet, ream and weight</b>
        <div style={{ marginTop: 12 }}><Grid>
          <Pick testid="paper-sheet" label="Sheet size" value={sheet} onChange={setSheet} options={SHEETS}/>
          {!pre && <Pick testid="paper-unit" label="Units" value={unit} onChange={(u) => { setP(convertVals(p, ["W", "H"], unit, u)); setUnit(u); }} options={[["in", "inches"], ["cm", "cm"], ["mm", "mm"]]}/>}
          {!pre && <Num testid="paper-w" label="Width" suffix={unit} value={p.W} onChange={set("W")}/>}
          {!pre && <Num testid="paper-h" label="Height" suffix={unit} value={p.H} onChange={set("H")}/>}
          <Num testid="paper-gsm" label="GSM" value={p.gsm} onChange={set("gsm")}/>
          <Num testid="paper-ream" label="Sheets per ream" value={p.ream} onChange={set("ream")} step={1}/>
          <Num testid="paper-qty" label="Number of sheets" value={p.qty} onChange={set("qty")} step={1}/>
          <Num testid="paper-kg" label="Weight you have" suffix="kg" value={p.kg} onChange={set("kg")}/>
          <Num testid="paper-rate" label="Paper rate" suffix="₹ per kg, optional" value={p.rate} onChange={set("rate")}/>
        </Grid></div>
      </div>
      <Grid min={160}>
        <Result testid="paper-sheet-weight" big label="Weight per sheet" value={`${fmt(g, 2)} g`}/>
        <Result testid="paper-ream-weight" big label="Ream weight" value={`${fmt(reamKg, 2)} kg`}/>
        <Result testid="paper-total-weight" label={`${fmt(Number(p.qty) || 0, 0)} sheets weigh`} value={`${fmt(totalKg, 2)} kg`}/>
        <Result testid="paper-sheets-in-kg" label={`Sheets in ${fmt(Number(p.kg) || 0, 0)} kg`} value={fmt(perKg * (Number(p.kg) || 0), 0)}/>
        <Result testid="paper-reams-in-kg" label={`Reams in ${fmt(Number(p.kg) || 0, 0)} kg`} value={reamKg ? fmt((Number(p.kg) || 0) / reamKg, 2) : "—"}/>
        <Result testid="paper-sheet-area" label="Sheet area" value={`${fmt(area, 4)} m²`}/>
        {rate > 0 && <Result testid="paper-cost" label="Cost · per sheet · per ream" value={`₹${fmt(totalKg * rate, 0)} · ₹${fmt((g / 1000) * rate, 3)} · ₹${fmt(reamKg * rate, 0)}`}/>}
      </Grid>
      <GsmLbs/>
    </div>
  );
}
